import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const MasterCategoryEmptyState = {
  masterCategories: [],
  selectedMasterCategory: null,
};

export const MasterCategoryKey = 'masterCategories';

export const masterCategoriesSlice = createSlice({
  name: 'masterCategories',
  initialState: getLocalStorage(LocalStorageTypes.MASTERCATEGORIES)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.MASTERCATEGORIES))
    : MasterCategoryEmptyState,
  reducers: {
    setMasterCategories: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.MASTERCATEGORIES, result);
      return { ...state, ...action.payload };
    },
    updateSelectedMasterCategory: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(MasterCategoryKey, result);
      return { ...state, ...action.payload };
    },
    resetMasterCategories: () => {
      clearLocalStorage('masterCategories');
      return MasterCategoryEmptyState;
    },
  },
});

export const {
  setMasterCategories,
  updateSelectedMasterCategory,
  resetMasterCategories,
} = masterCategoriesSlice.actions;
